export default {
  PERF_DATA_LOADING: '@PERF_DATA_LOADING',
  PERF_DATA_ERROR: '@PERF_DATA_ERROR',
  PERFORMANCE_DATA_SUCCESS: '@PERF_PERFORMANCE_DATA_SUCCESS',
  SALES_DATA_SUCCESS: '@PERF_SALES_DATA_SUCCESS',
  PERFORMANCE_DATA_RESET: '@PERF_DATA_RESET',

  TRANSACTION_DETAILS_LOADING: '@PERF_TRANSACTION_DETAILS_LOADING',
  TRANSACTION_DETAILS_ERROR: '@PERF_TRANSACTION_DETAILS_ERROR',
  TRANSACTION_DETAILS_SUCCESS: '@PERF_TRANSACTION_DETAILS_SUCCESS',
  RESET_TRANSACTION_DETAILS: '@PERF_RESET_TRANSACTION_DETAILS',

  TRANSACTION_DETAILS_V2_LOADING: '@PERF_TRANSACTION_DETAILS_V2_LOADING',
  TRANSACTION_DETAILS_V2_ERROR: '@PERF_TRANSACTION_DETAILS_V2_ERROR',
  TRANSACTION_DETAILS_V2_SUCCESS: '@PERF_TRANSACTION_DETAILS_V2_SUCCESS',
  RESET_TRANSACTION_DETAILS_V2: '@PERF_RESET_TRANSACTION_DETAILS_V2',

  TODAYS_SALES_LOADING: '@TODAYS_SALES_LOADING',
  TODAYS_SALES_ERROR: '@TODAYS_SALES_ERROR',
  TODAYS_SALES_SUCCESS: '@TODAYS_SALES_SUCCESS',

  MANAGER_SALES_LOADING: '@PERF_MANAGER_SALES_LOADING',
  MANAGER_SALES_ERROR: '@PERF_MANAGER_SALES_ERROR',
  MANAGER_SALES_SUCCESS: '@PERF_MANAGER_SALES_SUCCESS',
  MANAGER_SALES_CLEAR: '@PERF_MANAGER_SALES_CLEAR',

  MANAGER_SALES_TREE_LOADING: '@PERF_MANAGER_SALES_TREE_LOADING',
  MANAGER_SALES_TREE_ERROR: '@PERF_MANAGER_SALES_TREE_ERROR',
  MANAGER_SALES_TREE_SUCCESS: '@PERF_MANAGER_SALES_TREE_SUCCESS',
  MANAGER_SALES_TREE_CLEAR: '@PERF_MANAGER_SALES_TREE_CLEAR',
  MANAGER_SALES_TREE_SAVE_STATE: '@PERF_MANAGER_SALES_TREE_SAVE_STATE',
  MANAGER_SALES_TREE_CLEAR_CACHE: '@PERF_MANAGER_SALES_TREE_CLEAR_CACHE',
  MANAGER_SALES_TREE_RESTORE: '@PERF_MANAGER_SALES_TREE_RESTORE',

  PERF_FILTER_OPTIONS_LOADING: '@PERF_FILTER_OPTIONS_LOADING',
  PERF_FILTER_OPTIONS_SUCCESS: '@PERF_FILTER_OPTIONS_SUCCESS',
  PERF_FILTER_OPTIONS_ERROR: '@PERF_FILTER_OPTIONS_ERROR',

  PERF_SET_PERFORMANCE_FILTERS: '@PERF_SET_PERFORMANCE_FILTERS',
  PERF_CLEAR_PERFORMANCE_FILTERS: '@PERF_CLEAR_PERFORMANCE_FILTERS',
  PERF_SET_FILTER_LABELS: '@PERF_SET_FILTER_LABELS',

  MANAGER_SALES_DETAILS_LOADING: '@PERF_MANAGER_SALES_DETAILS_LOADING',
  MANAGER_SALES_DETAILS_ERROR: '@PERF_MANAGER_SALES_DETAILS_ERROR',
  MANAGER_SALES_DETAILS_SUCCESS: '@PERF_MANAGER_SALES_DETAILS_SUCCESS',

  ASSOCIATE_ENGAGEMENTS_LOADING: '@PERF_ENGAGEMENTS_LOADING',
  ASSOCIATE_ENGAGEMENTS_SUCCESS: '@PERF_ENGAGEMENTS_SUCCESS',
  ASSOCIATE_ENGAGEMENTS_ERROR: '@PERF_ENGAGEMENTS_ERROR',

  ASSOCIATE_REMINDERS_LOADING: '@ASSOCIATE_REMINDERS_LOADING',
  ASSOCIATE_REMINDERS_SUCCESS: '@ASSOCIATE_REMINDERS_SUCCESS',
  ASSOCIATE_REMINDERS_ERROR: '@ASSOCIATE_REMINDERS_ERROR',

  ASSOCIATE_REMINDER_UPDATE_SUCCESS: '@ASSOCIATE_REMINDER_UPDATE_SUCCESS',
  ASSOCIATE_REMINDER_UPDATE_ERROR: '@ASSOCIATE_REMINDER_UPDATE_ERROR',
  ASSOCIATE_REMINDERS_COUNT_SUCCESS: '@ASSOCIATE_REMINDER_UPDATE_ERROR',

  ASSOCIATE_MY_SCORECARD_LOADING: '@PERF_ASSOCIATE_MY_SCORECARD_LOADING',
  ASSOCIATE_MY_SCORECARD_SUCCESS: '@PERF_ASSOCIATE_MY_SCORECARD_SUCCESS',
  ASSOCIATE_MY_SCORECARD_ERROR: '@PERF_ASSOCIATE_MY_SCORECARD_ERROR',

  ASSOCIATE_EXP_SCORECARD_LOADING: '@PERF_ASSOCIATE_EXP_SCORECARD_LOADING',
  ASSOCIATE_EXP_SCORECARD_ERROR: '@PERF_ASSOCIATE_EXP_SCORECARD_ERROR',
  ASSOCIATE_EXP_SCORECARD_CLEAR: '@PERF_ASSOCIATE_EXP_SCORECARD_CLEAR',
  ASSOCIATE_EXP_SCORECARD_SUCCESS: '@PERF_ASSOCIATE_EXP_SCORECARD_SUCCESS',

  PERF_SET_PERFORMANCE_DATE_FILTER: '@PERF_SET_PERFORMANCE_DATE_FILTER',
  PERF_CLEAR_PERFORMANCE_DATE_FILTER: '@PERF_CLEAR_PERFORMANCE_DATE_FILTER',

  CALENDAR_RANGE_SET_DATE_RANGE: '@CALENDAR_RANGE_SET_DATE_RANGE',
  CALENDAR_RANGE_RESET_DATE_RANGE: '@CALENDAR_RANGE_RESET_DATE_RANGE',
};
